import React from 'react';
import { DeviceCreate } from '../../../api/models';
import { useI18n } from '../../../contexts/I18nContext';
import { ClientDetailState } from './useClientDetail';

/** The Devices tab: the client's devices, ten per page; a row opens the device. */
export const ClientDevicesTab: React.FC<{ state: ClientDetailState; onOpenDevice: (device: DeviceCreate) => void }> = ({ state, onOpenDevice }) => {
  const { formatDate, formatNumber, t } = useI18n();
  const { devices, devicesLoading, pagination, totalDevices, totalPages } = state;

  return (
    <div className="tab-content">
      <section className="cu-section">
        <header className="cu-section-head">
          <h3>
            {t('clients.associatedDevices')}
            <span className="ud-tab-count" data-testid="client-devices-total">{formatNumber(totalDevices)} {t('audit.stats.total').toLowerCase()}</span>
          </h3>
          <p>{t('clients.detail.devicesIntro')}</p>
        </header>

        {devicesLoading ? (
          <div className="tpd-empty"><p>{t('clients.detail.loadingDevices')}</p></div>
        ) : devices.length > 0 ? (
          <>
            <table className="tpd-table cl-devices-table">
              <thead>
                <tr>
                  <th>{t('clients.detail.colDevice')}</th>
                  <th>{t('clients.detail.colType')}</th>
                  <th>{t('clients.detail.colPhone')}</th>
                  <th>{t('clients.detail.colStatus')}</th>
                  <th>{t('clients.detail.colUpdated')}</th>
                </tr>
              </thead>
              <tbody>
                {devices.map((device) => (
                  <tr key={device.idDevice} className="cl-device-row" onClick={() => onOpenDevice(device)} data-testid={`client-device-${device.idDevice}`}>
                    <td><code>{device.idDevice}</code></td>
                    <td><span className="type-badge tpl-type">{device.deviceType || '?'}</span></td>
                    <td className="tpl-muted">{device.phone && device.phone !== '000000000000000' ? device.phone : '–'}</td>
                    <td>
                      <span className={`status-badge ${device.needsRefresh ? 'inactive' : 'active'}`}>
                        {device.needsRefresh ? t('clients.detail.deviceNeedsRefresh') : t('clients.detail.deviceOk')}
                      </span>
                    </td>
                    <td className="tpl-muted">{formatDate(device.dateTime)}</td>
                  </tr>
                ))}
              </tbody>
            </table>

            {totalPages > 1 && (
              <div className="cl-pager">
                <button type="button" className="btn btn-secondary btn-sm" onClick={() => state.goToPage(pagination.page - 1)} disabled={pagination.page === 1}>
                  {t('clients.detail.previous')}
                </button>
                <span className="cl-pager-info">{t('clients.detail.pageOf', { page: pagination.page, total: totalPages })}</span>
                <button type="button" className="btn btn-secondary btn-sm" onClick={() => state.goToPage(pagination.page + 1)} disabled={pagination.page === totalPages}>
                  {t('clients.detail.next')}
                </button>
              </div>
            )}
          </>
        ) : (
          <div className="tpd-empty"><p>{t('clients.detail.noDevices')}</p></div>
        )}
      </section>
    </div>
  );
};
